export default (route, store) => {
  let parentUrl = ''

  if (route.meta.index === 0) {
    store.commit('SET_INIT', [{
      name: route.meta.selfName,
      path: route.path
    }])
    parentUrl = route.path
    sessionStorage.removeItem('breadcrumbList')
  } else if (sessionStorage.breadcrumbList) {
    store.commit('SET_INIT', JSON.parse(sessionStorage.breadcrumbList))
    parentUrl = route.meta.parentUrl
      sessionStorage.removeItem('breadcrumbList')
  } else {
    store.commit('SET_BREADCRUMB', route)
    parentUrl = route.meta.parentUrl
  }
  //  对应aside
  store.commit('CHANGEASIDEACTIVE', parentUrl)


}
